const UPC_A_LENGTH = 12;

const EAN_13_LENGTH = 13;

const CHECK_DIGIT_MODULUS = 10;

const ODD_POSITION_WEIGHT = 3;

export function findGtin(scanned: string): null | string {
  const code = scanned.trim();

  if (!/^(?:\d{8}|\d{12,14})$/u.test(code)) {
    return null;
  }

  return hasValidCheckDigit(code) ? code : null;
}

export function isStoreInternalGtin(gtin: string): boolean {
  const ean13 = gtin.length === UPC_A_LENGTH ? `0${gtin}` : gtin;

  return ean13.length === EAN_13_LENGTH && /^(?:0[24]|2)/u.test(ean13);
}

function hasValidCheckDigit(gtin: string): boolean {
  const digits = [...gtin].map(Number);

  const checkDigit = digits.pop();

  const weightedSum = digits
    .toReversed()
    .reduce(
      (sum, digit, index) =>
        sum + digit * (index % 2 === 0 ? ODD_POSITION_WEIGHT : 1),
      0,
    );

  return (
    (CHECK_DIGIT_MODULUS - (weightedSum % CHECK_DIGIT_MODULUS)) %
      CHECK_DIGIT_MODULUS ===
    checkDigit
  );
}
